// TEMP page for José to screenshot the 3 owl avatar variants and share
// them on WhatsApp. Public route (no auth) so the URL itself is shareable.
// Delete this file + its route in App.js once the default variant is
// approved.
import React from "react";

const VARIANTS = [
  { id: "v1", label: "v1 — Default · cuerpo entero frontal" },
  { id: "v2", label: "v2 — Tres-cuartos · raqueta al frente" },
  { id: "v3", label: "v3 — Crop tight · cabeza y torso" },
];

const SIZES = [
  { px: 32,  label: "32px · navbar" },
  { px: 56,  label: "56px · perfil" },
  { px: 96,  label: "96px · dashboard" },
  { px: 160, label: "160px · hero" },
];

const Avatar = ({ src, px }) => (
  <span
    className="inline-flex items-center justify-center rounded-full bg-white border border-emerald-100 overflow-hidden shrink-0"
    style={{ width: px, height: px }}
  >
    <img src={src} alt="" className="w-full h-full object-cover" draggable={false} />
  </span>
);

const TestAvatars = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4 sm:px-8" data-testid="test-avatars-page">
      <div className="max-w-5xl mx-auto">
        <header className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">TEAM Owl — 3 variantes</h1>
          <p className="text-slate-600 mt-1 text-sm sm:text-base">
            Página temporal de comparación. Cada variante se muestra en 4 tamaños
            reales (navbar, perfil, dashboard, hero) para evaluar legibilidad.
          </p>
        </header>

        <div className="space-y-8">
          {VARIANTS.map((v) => (
            <section
              key={v.id}
              className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm"
              data-testid={`test-avatars-${v.id}`}
            >
              <h2 className="text-base sm:text-lg font-semibold text-slate-900 mb-4">
                {v.label}
              </h2>
              <div className="flex flex-wrap items-end gap-6 sm:gap-8">
                {SIZES.map(({ px, label }) => (
                  <div key={px} className="flex flex-col items-center gap-2">
                    <Avatar src={`/avatars/team-owl-avatar-${v.id}.png`} px={px} />
                    <span className="text-[11px] uppercase tracking-wide text-slate-400">
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>

        <footer className="mt-8 text-xs text-slate-400 text-center">
          Página de prueba — se elimina cuando José apruebe la variante final.
        </footer>
      </div>
    </div>
  );
};

export default TestAvatars;
